var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('h2',[_vm._v("Login")]),_c('div',{staticClass:"card w-50 mx-auto"},[_c('div',{staticClass:"card-body"},[_c('persist-user')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }